<h1>No batch found</h1>
<p>No batch currently found please try again</p>
<button (click)="retry()">Retry</button>